/**
 * Post-login redirect guard (RAISE-18933, epic RAISE-18890 D4).
 *
 * A redirect target is safe only when a browser resolves it on the current
 * origin: a single leading "/" followed by anything except another "/" or a
 * "\" (browsers treat "/\host" like "//host"), with no ASCII tab/newline/CR
 * (the URL parser strips them, so "/\t/host" becomes "//host") and no
 * backslash anywhere.
 */
const FALLBACK = "/";

// eslint-disable-next-line no-control-regex
const UNSAFE_CHARS = /[\u0000-\u001f\\]/;

export function isSafeRedirect(target: string | null | undefined): target is string {
  if (typeof target !== "string" || target.length === 0) return false;
  if (!target.startsWith("/")) return false;
  if (target.startsWith("//")) return false;
  return !UNSAFE_CHARS.test(target);
}

export function safeRedirectTarget(target: string | null | undefined): string {
  return isSafeRedirect(target) ? target : FALLBACK;
}
